import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { startOfMonth, endOfMonth, addDays, setMonth, format, subDays, differenceInDays, parseISO, isValid, parse, startOfDay, endOfDay } from 'date-fns';
import { es } from 'date-fns/locale';
import { Helps } from 'src/app/libs/helps';
import { Records } from '../../interfaces/records';
import { DateAdapter } from '@angular/material/core';
import { Facility } from '../../interfaces/facility';
import { Stores } from '../../interfaces/stores';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-list-records',
  templateUrl: './list-records.component.html',
  styleUrls: ['./list-records.component.css']
})
export class ListRecordsComponent  {
  active = 1;

}

